import { createAction, props } from '@ngrx/store';

import { LoadingActionTypes } from '../models';

export const addLoader = createAction(LoadingActionTypes.Add, props<{ id: string; loadingText: string }>());

export const removeLoader = createAction(LoadingActionTypes.Remove, props<{ id: string }>());
